export default __webpack_public_path__ + "static/media/signup.f91abfdc.png";